import { Pipe, PipeTransform } from '@angular/core';
import { QuoteOutput, QuoteProductType } from '@lx/quote-tool/shared/types';
import { Unpacked } from '@lx/shared/utils-ts';
import { isUnaccompaniedMinorsProduct } from '@lx/quote-tool/shared/data-access/quote';

@Pipe({
  name: 'lxUnaccompaniedMinorsByType',
  standalone: true,
})
export class UnaccompaniedMinorsByTypePipe implements PipeTransform {
  transform(
    products: QuoteOutput['products'],
    key?: keyof Unpacked<QuoteOutput['products']>,
  ): QuoteProductType | Unpacked<QuoteOutput['products']>[keyof Unpacked<QuoteOutput['products']>][] {
    const filteredProducts: QuoteOutput['products'] = products?.filter(isUnaccompaniedMinorsProduct);
    if (!filteredProducts?.length) {
      return null;
    }
    if (key) {
      return filteredProducts.map((product) => product[key]);
    }
    return filteredProducts;
  }
}
